import { render, staticRenderFns } from "./WebCustomerSwiper.vue?vue&type=template&id=6be765dc&scoped=true&"
import script from "./WebCustomerSwiper.vue?vue&type=script&lang=ts&"
export * from "./WebCustomerSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./WebCustomerSwiper.vue?vue&type=style&index=0&id=6be765dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be765dc",
  null
  
)

export default component.exports